import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import {
  Circle as BulletActive,
  ExpandMoreRounded as ExpandIcon,
  ReceiptOutlined as ReleaseIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

const releasingItemsConfig = [
  {
    permission: 24,
    label: "Releasing of Cheque (Internal)",
    to: "/cheque/issuing",
    notificationKey: "Internal Releasing of Cheque",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "pending",
  },
  {
    permission: 6,
    label: "Releasing of Cheque (External)",
    to: "/cheque/releasing",
    notificationKey: "External Releasing of Cheque",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "pending",
  },
  {
    permission: 38,
    label: "Cheque Date Adjustment",
    to: "/cheque/cheque-date-adjustment",
  },
  // {
  //   permission: 24,
  //   label: "Returned/Held Cheques",
  //   to: "/cheque/returned-issues",
  //   notificationKey: "Internal Releasing of Cheque",
  //   notificationArrayProp: "cheque",
  //   isLoadingProp: "isChequeLoading",
  //   notificationValue: "return",
  // },
];

const SidebarReleasingDropdown = ({
  activeDropdown,
  user,
  cheque,
  shouldDisplayDotNotification,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/issuing|releasing/gi));

  const allNotifications = {
    "Internal Releasing of Cheque": cheque,
    "External Releasing of Cheque": cheque,
  };

  const allLoadingStates = {
    isChequeLoading,
  };

  const hasNotifications = releasingItemsConfig.some(
    (item) =>
      user.permissions.includes(item.permission) &&
      item.notificationKey &&
      shouldDisplayDotNotification(allNotifications[item.notificationKey], item.notificationKey)
  );

  return (
    <Accordion defaultExpanded={/treasury/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={
          isActiveDropdown
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <ReleaseIcon />
        <Typography variant="sidebar">Releasing</Typography>
        {hasNotifications ? <BulletActive className="FstoSidebarActiveNotif-root" /> : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {releasingItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {item.notificationKey && !allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification
                    notificationArray={allNotifications[item.notificationKey]}
                    permission={item.notificationKey}
                    value={item.notificationValue}
                  />
                )}
              </RouterLink>
            )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarReleasingDropdown;
